// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__nkOul","btn__label":"button_btn__label__jT32k"};